import { Button } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import { Seo } from 'components'
import { useRootLink } from 'hooks/useRootLink'

import { TechPageTemplate } from '../template'

export const NotAccessPage = () => {
  const navigate = useNavigate()
  const rootLink = useRootLink()

  const handleClick = () => {
    if (!rootLink) {
      return
    }
    navigate(rootLink)
  }

  return (
    <>
      <TechPageTemplate
        text="Вы запросили страницу, доступ к которой ограничен. Возможно, это закрытая информация или личные файлы другого пользователя."
        title="Недостаточно прав для просмотра"
        actions={
          <Button disabled={!rootLink} onClick={handleClick} size="lg" variant="outline">
            Перейти на главную
          </Button>
        }
        icon={
          <div
            className="mb-5 flex h-[116px] w-[116px] items-center justify-center rounded-full bg-brand text-[48px] text-on-primary md:mb-10"
            data-test-id="not--access--page"
          >
            403
          </div>
        }
      />
      <Seo description="Похоже, у вас нет доступа к данной странице." title="Доступ к странице запрещен" />
    </>
  )
}
